import {Fragment, h} from 'preact';
import ContractInfo from "./ContractInfo";

export default function SirenaContractRow({contract, account, amounts, onChangeCheckbox, isChecked, onChangeAmountInput, formParams, createOrderForContract, details, devices}){
	const {meterDevices} = contract;
	let canEnterMeterReadings = false;
	let enterUrl = null;
	meterDevices.map(device => {
		if(device.canEnterMeterReadings) {
			canEnterMeterReadings |= true;
			enterUrl = device.enterUrl;
		} else {
			canEnterMeterReadings |= false;
		}
	});
	const columnTitleClass = isChecked ? 'form-field__input-row form-field__input-row_ai_center':'';
	return (
		<Fragment>
			{!contract.isClosed && meterDevices.length > 0 && <ContractInfo
				canEnterMeterReadings={canEnterMeterReadings}
				enterUrl={enterUrl}
				contract={contract}
				account={account}
				formParams={formParams}
				amounts={amounts}
				createOrderForContract={createOrderForContract}
				onChangeAmountInput={onChangeAmountInput}
				details={details}
				devices={devices}
			/>}
			{!!contract.isClosed && (
				<div className="debt-table-item-2 debt-table__item">
					<div className="debt-table-item-2__row">
						<div className="debt-table-item-2__col"/>
						<div className="debt-table-item-2__col debt-table-item-2__col_fg_1">
							<div className="debt-table-item-2__text">
								Передача показаний невозможна, с {contract.closeDate} договор расторгнут
							</div>
						</div>
					</div>
				</div>
			)}
		</Fragment>
	);
}
